import React from 'react';
import { platformNames } from '../../data/blackout';
export function PressStrip() {
  return <section aria-label="Where the silhouette has appeared" className="border-y border-gunmetal/60 bg-carbon" data-id="element-249" data-mp="2po3cjfco7k86">
      <div className="no-scrollbar mx-auto flex max-w-7xl items-center gap-8 overflow-x-auto px-5 py-5 md:justify-between md:px-8" data-id="element-250" data-mp="2ugo3m946zj80">
        <p className="shrink-0 whitespace-nowrap text-[11px] font-medium uppercase tracking-[0.18em] text-steel" data-id="element-251" data-mp="2zgiz6pywwwze">
          The silhouette seen on
        </p>
        <ul className="flex shrink-0 items-center gap-8 md:gap-10" data-id="element-252" data-mp="26qtwm86k0ovo">
          {platformNames.map(name => <li key={name} className="whitespace-nowrap font-display text-lg uppercase tracking-[0.06em] text-bone/55 md:text-xl" data-id="element-253" data-mp="2bnai0umdcp52">
              {name}
            </li>)}
        </ul>
      </div>
    </section>;
}